"use strict";
var Observable_1 = require('../../Observable');
var zip_1 = require('../../observable/zip');
Observable_1.Observable.zip = zip_1.zip;
//# sourceMappingURL=zip.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/zip.js
 ** module id = 474
 ** module chunks = 2
 **/